import { SapSuppliersAdd } from "@/features"

const SapSuppliersAddPage = () => {
  return <SapSuppliersAdd />
}

export default SapSuppliersAddPage
